<template>
   <palletinfodashboard>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
      <!--  <b-breadcrumb :items="breadcrumbs"/>   -->  
       <b-card header-tag="header" footer-tag="footer">
      
        <b-row class="mb-4">          
    
           
        
           <b-col sm="12" class="text-right">
             <!-- <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>        
        </b-row>

            <!--   <b-table  v-if="this.totalRows > 0" style="text-align: left" show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div> 
              <template slot="rider_names" slot-scope="row">
             mukesh
            </template> 
        
          </b-table> -->
            <div class="table-responsive" >
              <div style="float: left;" v-if="this.totalRows > 0">
               <span  class="badge badge-primary">PR</span>&nbsp;&nbsp;&nbsp;Indicates Privilege Rider
             </div>
             <br>
            <table class="table table-striped table-bordered" border="1" v-if="this.totalRows > 0" >
              <thead style="text-align: left" >
                <tr>
                  <th>Pallet Title</th>
                  <th>Rider Name</th>
                  <th>Total Count</th>
               
                </tr>
              </thead>
              <tbody>
                <tr style="text-align: left">
                  
                  <td>{{ pallet_title }}</td>
                  <td><span class="badge badge-primary" v-if="isprivillage== 1">PR</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ rider_name }}</td>
                   <td>{{ total_count }}</td>
                  
                </tr>
              </tbody>
            </table>
          </div>
            <b-table  v-if="this.totalRows > 0" style="text-align: left" show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields1"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div> 
              <template slot="ridername" slot-scope="row">
             {{row.item.deliveryagentfirstname}} {{row.item.deliveryagentlastname}}
            </template> 
        
          </b-table>
            

                    
                    <b-col md="12" class="my-1 " v-if="this.totalRows > 10" >
            <!-- <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination> -->
   <!--            <paginate
   
    :page-count="noofpages"
    :page-range="10"
    :margin-pages="2"
    :click-handler="clickCallback"
    :prev-text="'Prev'"
    :next-text="'Next'"
    :container-class="'pagination'"
    :page-class="'page-item'">
  </paginate> -->
          </b-col> 
      


       
       </b-card>
        
      </b-col>
    </b-row><!--/.row-->

  </div>
   </palletinfodashboard>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default {
  mounted() {  
    
      EventBus.$on("clicked-event", pid=> {  
  
  this.displaydata(pid); 
      });  
   }  ,
  data: function() {
    return {
      name: 'codReports',
      data: [],
       records:[],
      items:[],
      data:[],
      pallet_title:'',
      rider_name:'',
      total_count:'',
      isprivillage:'',

       // fields: [
       //  { key: 'pallet_titles', label: 'Pallet Title', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
       //    { key: 'rider_names', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
          
       //       { key: 'total_counts', label: 'Total Count', sortable: true, sortDirection: 'desc' },
         
          
       //    // { key: 'shipaddress1', label: 'Shipping Address', sortable: true, sortDirection: 'desc' },
       //    // { key: 'locality_city_name', label: 'Shipping City', sortable: true, sortDirection: 'desc' },
       //    // { key: 'locality_name', label: 'Stae Name', sortable: true, sortDirection: 'desc' },

          
          
       //   ], 
            fields1: [
       
            { key: 'locality_name', label: 'Locality Name', sortable: true, sortDirection: 'desc' },
             { key: 'shipment_count', label: 'Shipment Count', sortable: true, sortDirection: 'desc' },
          
          
          
         ], 
      headinglength:0,
      isBusy: false,
       page:1,
    
     
      bordered: true,
       disabled: '',
      totalRows: 0,
      itemsperpages:5,
      currentPage: 1,
      perPage:  20,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
      pageNum:1,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selectDateTo: new Date(),
       selectDateFrom: new Date(),
    }

  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  created: function () {
    var palletids = JSON.parse(localStorage.getItem("palletid"));
    this.displaydata(palletids)
  
  },

  methods: {
    // 
        displaydata: function (palletid) {

     
  // alert(palletid);
      
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     // {"pallet_id":"40"}
     
if(palletid!=null||palletid!=undefined)
{
       const info = {
        pallet_id: palletid, 
        hub_id:`${userInfo.pickuplocationmasterid}`,
        
      
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getlocalitywiseshipmentforpallet`,info)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
           // document.getElementById("printbutton").style.display ="block";
             this.items  = result.body.returnvalue;
             // this.data  = result.body.returnvalue[0];
                this.pallet_title=result.body.returnvalue[0].pallet_title;
                this.rider_name=result.body.returnvalue[0].rider_name;

                this.total_count=result.body.returnvalue[0].total_count;
                this.isprivillage=result.body.returnvalue[0].privilege_rider;
              // console.log(this.data);
             this.totalRows = 1;
             this.isBusy = !this.isBusy;
             // this.customer.pallet_id='';
             
          } else {
          this.isBusy = !this.isBusy
              this.items=[];  
               this.pallet_title='';
                this.rider_name='';

                this.total_count=''; 
           
            this.totalRows = 0;
              Utils.notify("No Records Found",'error');
              // this.$fire({
              //     text:"No Records Found",
              //     type: "error",
              //     timer: 30000
              //   }); 

            
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      
     

   }
     
     
      
    },
    

   

  
     clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showdashboarddetails(pageNum);
    },
    downloadCSV: function() {
     


    
      
          var csvObj = {
   
          pallet_id:49,
          hub_id:`${userInfo.pickuplocationmasterid}`,
            
           
          };
         
      

      // console.log(csvObj);
     
      
        var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
    
  this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/getpalletshipmentlistcsv`+queryString)
        .then(result => {
         // console.log(result.url);
        window.location.href =result.url;
        });
        
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    
    


    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>

<style type="text/css">
 .totalback
 {
  background: #c8ced3 !important;
   border-right: 1px solid grey !important;
   max-width: 300px !important;
    
  }

  .hidden_header {
    
  display: none;
}
   .pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  border: 1px solid #ddd;
}


.page-item.active {
  background-color: #87CEEB;
    color: white;
}

.pagination a:hover:not(.active) {background-color: #ddd;}
  

</style>
